import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  useLocation,
} from "react-router-dom";
import { HomeScreen } from "./routes/home/HomeScreen";
import { BottomNavigation } from "./routes/components/BottomNavigation";
import { Login } from "./routes/auth/Login";
import { config } from "@fortawesome/fontawesome-svg-core";
import { SplashScreen } from "./routes/components/SplashScreen";
import { TopNavigation } from "./routes/components/TopNavigation";
import ProductDetail from "./routes/home/components/ProductDetail";
import { Profile } from "./routes/home/components/Profile";
import { Search } from "./routes/home/components/Search";
import { Activity } from "./routes/home/components/Activity";
import CreatePost from "./routes/home/components/CreatePost";

config.autoAddCss = false;

const AppLayout = () => {
  const location = useLocation();
  return (
    <div className="h-[100vh] w-[100vw] overflow-hidden fixed">
      {location.pathname !== "/" && (
        <>
          <TopNavigation />
        </>
      )}
      <Outlet />
      <BottomNavigation />
    </div>
  );
};

const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      {
        path: "/",
        element: <SplashScreen />,
      },
      {
        path: "/home",
        element: <HomeScreen />,
        children: [],
      },
      {
        path: "/product",
        element: <ProductDetail />,
        children: [],
      },
      {
        path: "/profile",
        element: <Profile />,
      },
      {
        path: "/search",
        element: <Search />,
      },
      {
        path: "/activity",
        element: <Activity />,
      },
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/create-post",
    element: <CreatePost />,
  },
]);
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
